import type { SampleStyleData } from '../../types';

import { randNumber, randWord } from '@ngneat/falso';

import { mockSampleStyleOptionData } from './mockSampleStyleOptionData';

/**
 * Returns a mocked SampleStyleData (as returned by `getStyleEanForStyle`) with
 * two colour options by default. Override `styleOptions` for a specific count.
 */
const mockSampleStyleData = (
    overwrite?: Partial<SampleStyleData>
): SampleStyleData => ({
    styleNumber: randNumber({ min: 12000000, max: 12999999 }),
    styleName:
        `${randWord({ capitalize: true })} ${randWord({ capitalize: true })}`.toUpperCase(),
    productLineNumber: String(randNumber({ min: 1, max: 99 })),
    masterStyleSubCategoryNumber: String(randNumber({ min: 1, max: 999 })),
    styleOptions: [mockSampleStyleOptionData(), mockSampleStyleOptionData()],
    ...overwrite,
});

export { mockSampleStyleData };
